const GRADE_STYLES = {
  A: { chip: "bg-emerald-100 text-emerald-700", bar: "bg-emerald-500" },
  B: { chip: "bg-blue-100 text-blue-700", bar: "bg-blue-500" },
  C: { chip: "bg-amber-100 text-amber-700", bar: "bg-amber-500" },
  D: { chip: "bg-red-100 text-red-700", bar: "bg-red-500" },
};

const DEFAULT_GRADE_STYLE = { chip: "bg-slate-100 text-slate-600", bar: "bg-slate-300" };

export function getGradeStyle(grade) {
  return GRADE_STYLES[grade] || DEFAULT_GRADE_STYLE;
}
